import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios, { MEDIA_BASE_URL } from "../../axios/axios";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import normalizeContentLinks from "../../utils/normalizeContentLinks";

const SingleBlogPage = () => {
  const { id } = useParams(); // Get blog ID from URL
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await axios.get(`blog/${id}`);
        setBlog(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching blog:", err);
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (!blog) return <div className="text-center py-5">Blog not found.</div>;

  return (
    <>
      <Navbar />
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            {/* Featured Image */}
            <div className="mb-4">
              <img
                src={`${MEDIA_BASE_URL}/${blog.image}`}
                crossOrigin="anonymous"
                alt="Featured Image"
                className="img-fluid rounded-3 shadow-sm"
                style={{ width: "100%", height: "400px", objectFit: "cover" }}
              />
            </div>

            {/* Category Badge */}
            <div className="mb-3">
              <span
                className="badge px-3 py-1"
                style={{
                  backgroundColor: "#20B2AA",
                  borderRadius: "20px",
                  fontSize: "0.9rem",
                }}
              >
                {blog.service}
              </span>
            </div>

            {/* Title */}
            <h1
              className="mb-4"
              style={{ color: "#2c3e50", fontWeight: "300" }}
            >
              {blog.title}
            </h1>

            {/* Content */}
            <div className="mb-5">
              <div
                className="blog-content"
                style={{
                  lineHeight: "1.8",
                  fontSize: "1.1rem",
                  color: "#495057",
                }}
                dangerouslySetInnerHTML={{
                  __html: normalizeContentLinks(blog.description),
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SingleBlogPage;
